const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded', () => {

    const nav = document.querySelector('.js-nav'),
          hamburger = document.querySelector('.js-hamburger'),
          menu = document.querySelector('.js-menu'),
          newsbar = document.querySelector('.js-newsbar');

    const init = () => {

        window.hideMenu = function() {
            document.querySelector('.js-nav').classList.remove('is-visible');
            document.querySelector('.js-hamburger').classList.remove('is-active');
            
            document.removeEventListener('click', clickOutside);
            document.documentElement.classList.remove('menu-opened');
            
            setTimeout(() => {
                document.querySelector('.js-nav').classList.remove('is-block');
                document.querySelector('.js-nav').classList.remove('is-animated');
            }, 500);
            
            enableBodyScroll(menu);
        };

        const showMenu = () => {
            nav.classList.add('is-block');
            hamburger.classList.add('is-active', 'is-disabled');
            document.documentElement.classList.add('menu-opened');

            setTimeout(function() {
                nav.classList.add('is-visible');
                document.addEventListener('click', clickOutside);
//                showLinks();
            }, 10);
            
/*
            const showLinks = function() {
                const blocks = menu.querySelectorAll("li");
                const tl = gsap.timeline().delay(.1).eventCallback("onComplete", () => {
                          nav.classList.add('is-animated');
                          hamburger.classList.remove('is-disabled');
                      })

                .from(blocks, {
                    x: 50,
                    opacity: 0,
                    stagger: {
                        each: 0.1
                    }
                });                
            };
*/

            disableBodyScroll(menu);
        };

        const toggleMenu = function(e) {
            nav.classList.contains('is-visible') ? hideMenu() : showMenu();
        };

        hamburger.addEventListener('click', toggleMenu);
        
        const clickOutside = function(e) {
            if (!e.target.closest('.js-nav')) {
                hideMenu();
        	}
        };

        // Hide menu on ESC
        document.addEventListener('keydown', (evt) => {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hideMenu();
            }
        });
    };

    nav ? init() : false;

}, false);


document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".menu-item-has-children > a");

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault(); // zapobiega przeładowaniu linku
      const parentLi = this.parentElement;
      const submenu = parentLi.querySelector(".o-menu__submenu");

      const isOpened = parentLi.classList.contains("is-opened");

      if (isOpened) {
        // ZWIJANIE
        submenu.style.height = submenu.scrollHeight + "px"; // ustaw najpierw aktualną wysokość
        requestAnimationFrame(() => {
          submenu.style.height = "0";
        });

        parentLi.classList.remove("is-opened");

        submenu.addEventListener("transitionend", function handler() {
          submenu.style.removeProperty("height");
          submenu.style.removeProperty("overflow");
          submenu.removeEventListener("transitionend", handler);
        });

      } else {
        // ROZWIJANIE
        submenu.style.height = "0";
        submenu.style.overflow = "hidden";
        parentLi.classList.add("is-opened");

        // wymuś reflow
        submenu.offsetHeight;

        submenu.style.height = submenu.scrollHeight + "px";

        submenu.addEventListener("transitionend", function handler() {
          submenu.style.height = "auto";
          submenu.style.overflow = "auto";
          submenu.removeEventListener("transitionend", handler);
        });
      }
    });
  });
});
